import availableStates from '../../../../../helpers/availableStatesHelper'

export default function () {
    return {
        availableStates,
        availableCities: [],
        availableCompanyCities: [],
        isLoadingCities: false,
        isLoadingCompanyCities: false,
        isRegistered: false,
        user: {
            name: '',
            cpf: '',
            birthDate: '',
            phone: '',
            biography: '',
            address: {
                zipCode: '',
                street: '',
                number: null,
                complement: '',
                neighbourhood: '',
                city: '',
                state: ''
            },
            company: {
                cnpj: '',
                name: '',
                address: {
                    zipCode: '',
                    street: '',
                    number: null,
                    complement: '',
                    neighbourhood: '',
                    city: '',
                    state: ''
                }
            },
            password: '',
            passwordConfirmation: ''
        },
        showPassword: false,
        showPasswordConfirmation: false,
        formattedUserBirthDate: '',
        showBirthDatePicker: false,
        showCpfCnpjRequired: false,
        errors: {
            name: '',
            cpf: '',
            birthDate: '',
            phone: '',
            password: '',
            passwordConfirmation: '',
            biography: '',
            'address.zipCode': '',
            'address.street': '',
            'address.numer': '',
            'address.complement': '',
            'address.neighbourhood': '',
            'address.city': '',
            'address.state': '',
            'company.cnpj': '',
            'company.name': '',
            'company.address.zipCode': '',
            'company.address.street': '',
            'company.address.numer': '',
            'company.address.complement': '',
            'company.address.neighbourhood': '',
            'company.address.city': '',
            'company.address.state': ''
        },
        errorMessage: {
            show: false,
            content: null,
            timeout: 5000
        },
        successMessage: {
            show: false,
            content: null,
            timeout: 5000
        },
        editorToolbar: [
            ['bold'],
            [{ list: "ordered" }, { list: "bullet" }]
        ]
    }
}
